import { CandidateData } from '$types/candidates';
import SPKShowcaseCandidateInfo from '../SPKShowcaseCandidateInfo/SPKShowcaseCandidateInfo';

type ShowcaseAudioFile = NonNullable<CandidateData['Files']>[number];

const SPKEmployerShowcaseAudioModal = ({
  selectedAudio,
  title,
  candidate,
}: {
  selectedAudio: ShowcaseAudioFile;
  title: string;
  candidate: CandidateData;
}) => {
  return (
    <div className="flex flex-col overflow-auto bg-white py-5 px-4 rounded-2xl w-full">
      <SPKShowcaseCandidateInfo candidate={candidate} />
      <div
        className={`${
          selectedAudio.Description ? 'mb-1' : 'mb-4'
        } text-spk-highContrast text-base font-bold`}
      >
        {title}
      </div>
      {!!selectedAudio.Description && (
        <div className="mb-4 text-spk-mediumContrast text-sm">
          {selectedAudio.Description}
        </div>
      )}
      <audio className="w-full" src={selectedAudio.Url} controls>
        <track kind="captions" />
      </audio>
    </div>
  );
};

export default SPKEmployerShowcaseAudioModal;
